import Url from '../global/Url';

async function getLeadGenerator(Campaign, Oferta, Operadora, Base) {
    const query = new URLSearchParams({
        campaign: Campaign ?? '',
        oferta: Oferta ?? '',
        operadora: Operadora ?? '',
        base: Base ?? '',
    });

    try {
        const response = await fetch(Url.Crm + 'generador?' + query.toString());
        const responseJson = await response.json();
        const res = responseJson.body;
        // La API devuelve [] cuando la terna Forma+Oferta+Operadora no existe en
        // 'adicionales'. Siempre array: quien llama hace Generador[0].nombre.
        return Array.isArray(res) ? res : [];
    } catch (error) {
        console.error(`ERROR GENERADOR: ${error}`);
        return [];
    }
}

export { getLeadGenerator };
